<script>
  import {mapActions, mapGetters} from 'vuex'
  import StepAppointment from './StepAppointment.vue'
  import StepHospitalSelector from './StepHospitalSelector.vue'
  import StepPrivacyAgreement from './StepPrivacyAgreement.vue'
  import StepSsnDetails from './StepSsnDetails.vue'
  import StepTreatmentSelector from './StepTreatmentSelector.vue'
  import LegalTerms from './LegalTerms.vue'

  export default {
    name: 'Form',

    components: {
      StepHospitalSelector,
      StepPrivacyAgreement,
      StepTreatmentSelector,
      StepAppointment,
      StepSsnDetails,
      LegalTerms,
    },

    computed: {
      ...mapGetters(['isStepCompleted']),
    },

    mounted: function () {
      this.$analytics.pushEvent("form:start");
    },

    methods: {
    },
  }
</script>

<template>
  <div class="col-md-8">
    <div class="form">
      <div class="steps">
        <StepHospitalSelector :is-completed="isStepCompleted(0)" v-if="$config.enableHospitalsChoice"/>
        <StepPrivacyAgreement :is-completed="isStepCompleted(1)" :is-ready="isStepCompleted(0)"/>
        <StepTreatmentSelector :is-completed="isStepCompleted(2)" :is-ready="isStepCompleted(1)"/>
        <StepAppointment :is-completed="isStepCompleted(3)" :is-ready="isStepCompleted(2)"/>
        <StepSsnDetails :is-completed="isStepCompleted(4)" :is-ready="isStepCompleted(3)" v-if="$config.enableSSN"/>
      </div>
      <LegalTerms/>
    </div>
  </div>
</template>